import { CustomFieldsTable } from './CustomFieldsTable';
import { ContentBox } from '../../common/components/AppLayout/ContentBox';
import { TableSkeleton } from '../../common/components/Table/TableSkeleton';
import { SuspenseLoadingView } from '../../common/components/SuspenseLoadingView';
import { customFieldsQuery } from './utils/queries';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { useTranslation } from 'react-i18next';

export const CustomFieldsPage = () => {
  const { t } = useTranslation();
  return (
    <TabPanelWithErrorHandling name={t('customFields.customFields')}>
      <SuspenseLoadingView
        loadFallback={
          <ContentBox>
            <TableSkeleton showStartSkeleton showEndSkeleton numberOfRows={10} />
          </ContentBox>
        }
        queryKey={customFieldsQuery.all}
      >
        <CustomFieldsTable />
      </SuspenseLoadingView>
    </TabPanelWithErrorHandling>
  );
};
